// Set the name of the hidden property and the change event for visibility
let hidden, visibilityChange;
if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
}

const pageVisibility = {
    listeners: [],
    state: 'visible',
    subscribe(callback) {
        this.listeners.push(callback);
    },
    broadcast(value) {
        this.state = value;
        this.listeners.forEach(listener => listener(value));
    }
};

function handleVisibilityChange() {
    if (document[hidden]) {
        pageVisibility.broadcast('hidden');
    } else {
        pageVisibility.broadcast('visible');
    }
}

// Warn if the browser doesn't support addEventListener or the Page Visibility API
if (typeof document.addEventListener === 'undefined' || typeof document.hidden === 'undefined') {
    // NOTE: requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.
} else {
    // Handle page visibility change
    document.addEventListener(visibilityChange, handleVisibilityChange, false);
}

export default pageVisibility;
